import { PricingGrid } from './PricingGrid'

export function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-surface-50">
      <div className="mx-auto max-w-7xl section-padding">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-surface-900 mb-4">
            Pricing that reflects how hiring actually works
          </h2>
          <p className="text-lg text-surface-600">
            You pay for active roles and candidates—when judgment work happens. No per-seat fees. No per-resume charges.
          </p>
        </div>

        {/* Plans grid */}
        <PricingGrid />
        

        {/* Bottom note */}
        <p className="text-center text-sm text-surface-500 mt-8">
          Scale back when hiring slows down. No long-term commitments required.
        </p>
      </div>
    </section>
  )
}
